import script from "./TabbarCom.vue?vue&type=script&setup=true&lang=js"
export * from "./TabbarCom.vue?vue&type=script&setup=true&lang=js"

import "./TabbarCom.vue?vue&type=style&index=0&id=6e232b22&lang=css"

const __exports__ = script;

export default __exports__